import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CrmApiService } from '@shared/core';
import { convertApiItemResponseToItem, convertApiResponseToPaginable } from '@shared/core/utils';
import { DEFAULT_REQUEST_PARAMS } from '@shared/core/types';
import { EmailItemList, EmailItemListResponse, EmailsUnreadCount, EmailsUnreadCountResponse } from '../types';

@Injectable({
  providedIn: 'root',
})
export class MailNotifierApiService extends CrmApiService {
  getCount(): Observable<EmailsUnreadCount> {
    return this.api
      .get<EmailsUnreadCountResponse>(
        `${this.baseEndpoint}communication/incoming-communications/count-unread-notifications/`,
      )
      .pipe(
        convertApiItemResponseToItem,
        map(data => data.count),
        catchError(() => of(null)),
      );
  }

  getEmails(page?: number): Observable<EmailItemList> {
    return this.api
      .get<EmailItemListResponse>(
        `${this.baseEndpoint}communication/incoming-communications/list-unread-notifications/`,
        {
          params: {
            page,
          },
          ...DEFAULT_REQUEST_PARAMS,
        },
      )
      .pipe(convertApiResponseToPaginable);
  }
}
